module.exports = __webpack_public_path__ + "images/icon_menu_5de4b7173608536c0f2aa051ab2c3d29.svg";